import { Component } from '@angular/core';

import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';
import { Population, SelectedItem } from '../../../../user/population-select';
import { DataDimension, ReportType } from '../../../backend';
import { currentBuilderState } from '../../builder.state';
import { updateSectionLabels } from '../../function/update-section-labels.function';
import { BuilderState } from '../../model/builder-state.model';
import { SelectionService } from '../../service/selection.service';

@Component({
    selector: 'cmps-report-builder-dimension',
    templateUrl: './dimension.component.html',
})
@TakeUntilDestroy()
export class DimensionComponent {
    /** @private */
    readonly _ReportType = ReportType;

    /** @private */
    readonly _DataDimension = DataDimension;

    /** @private */
    readonly _Population = Population;

    /** @private */
    _state: BuilderState;

    constructor(private readonly _selectionService: SelectionService) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onChange(wasSite: boolean = false): void {
        this._selectionService.onDimensionsChange(wasSite);
    }

    /** @private */
    _onSiteLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            site: value,
        });
    }

    /** @private */
    _onQueueLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            queue: value,
        });
    }

    /** @private */
    _onSuperGroupLabelChange(value: SelectedItem[]): void {
        updateSectionLabels({
            ...this._state.viewParams,
            superGroup: value,
        });
    }
}
